enum PropertyLength {
  ID = 10,
  NAME = 100,
  EMAIL_ADDRESS = 512,
  PHONE_NUMBER = 20,
  MEDIUM_TEXT = 255,
  SMALL_TEXT = 50,
  DELIMITER = 10,
}

export { PropertyLength };
